module.exports = __webpack_public_path__ + "static/media/incrowd3.7e56159a.gif";